$(document).ready(function() {
  $('[data-tooltip="true"]').tooltip()
})
